import { render, staticRenderFns } from "./GatTab.vue?vue&type=template&id=6b346a0a&"
import script from "./GatTab.vue?vue&type=script&lang=js&"
export * from "./GatTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports